export interface Exchange {
  From: string;
  FromCode:string;
  FromSymbol:string;
  To: string;
  ToCode:string;
  ToSymbol:string;
  ExchangeRate?: number;
  AgencyRate?:number;
  Fees?: number;
  Id: string;
  Label:string;


}

export class ExchangeFormValues implements Partial<Exchange> {
  From = "";
  FromCode="";
  FromSymbol=''
  To = "";
  ToCode="";
  Id = "";
  ToSymbol='';
  Label="";
  ExchangeRate=undefined;
  AgencyRate=0;
  Fees=undefined;

  constructor(init?: Partial<Exchange>) {
    Object.assign(this, init);
  }
}
